import { PlatformIcon } from "@/app/Promotions/Components/PlatformIcon";
import { promotionPlatformLabelMap } from "@/app/Promotions/Utils/promotionMaps";
import { PromotionPlatform } from "@/gql/graphql";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/16/solid";

export function PlatformCell({
  platform,
  managerUrl,
}: {
  platform: PromotionPlatform;
  managerUrl?: string | null;
}) {
  const content = (
    <>
      <PlatformIcon platform={platform} enabled className="h-4 w-4" />
      {promotionPlatformLabelMap[platform]}
    </>
  );

  if (!managerUrl) {
    return (
      <div className="flex items-center gap-2 whitespace-nowrap font-medium text-gray-900">
        {content}
      </div>
    );
  }

  return (
    <a
      href={managerUrl}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="group flex items-center gap-2 whitespace-nowrap font-medium text-gray-900 hover:underline"
    >
      {content}
      <ArrowTopRightOnSquareIcon className="size-3.5 text-gray-400 opacity-0 transition group-hover:opacity-100" />
    </a>
  );
}
